import { render, staticRenderFns } from "./comp_Hook-ShopList-FilterOrderBy.vue?vue&type=template&id=1612475b&"
import script from "./comp_Hook-ShopList-FilterOrderBy.vue?vue&type=script&lang=js&"
export * from "./comp_Hook-ShopList-FilterOrderBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
